<template>
  <section class="view-wrap">
    <div class="basic-grid custom-grid">
      <div class="box" v-if="data">
        <!-- <img v-if="data.hero_image_top" :src="data.hero_image_top.url"> -->
        <h1 class="size-2">{{ data.title }}</h1>
        <!-- STREAMFIELD -->
        <div class="streamfield" v-for="c in data.content" v-bind:key="c.value">
          <div v-html="c.value" v-if="c.type != 'script_block'"></div>
        </div>
        <!-- <span v-if="data.related_items">
            <span v-for="section in data.related_items" v-bind:key="section.value.id">
              <RelatedItems :relatedInfo="section.value" :pageNodes="data.node"/>
            </span>
        </span> -->
        <div id='script-section'></div>
        <!-- END STREAMFIELD -->
      </div>
      <!-- <SVGBack /> -->
    </div>
  </section>
</template>

<script>
import axios from 'axios'
// import RelatedItems from '@/components/RelatedItems.vue'
import SVGBack from '@/components/SVGAnimation.vue'
export default{
  name: 'CustomPage',
  data(){
    return{
      data: null,
    }
  },
  components: {
    // RelatedItems,
    SVGBack
  },
  mounted() {
    this.fetchData().then(data =>{
      this.data = data
      this.grouped_pages = data.grouped_pages
      let ele = document.getElementById('script-section');
      for (let c in this.data.content){
        if (this.data.content[c].type === 'script_block') {
          let temp = document.createRange().createContextualFragment(this.data.content[c].value)
          ele.append(temp);
        }
      }
      if (this.data.custom_styles) {
        let styles = document.createElement('style');
        styles.type = 'text/css';
        styles.id = 'temp-styles';
        for (let d in this.data.custom_styles) {
          if (!this.data.custom_styles[d].value.hide) {
            styles.appendChild(document.createTextNode(this.data.custom_styles[d].value.style));
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    })
  },
  beforeRouteLeave (to, from, next){
    if (this.data.custom_styles) {
      let tempSty = document.getElementById('temp-styles');
      if (tempSty) {
        tempSty.remove();
      }
    }
    next();
  },
  created (){
    this.fetchData().then(data =>{
      this.data = data
      this.grouped_pages = data.grouped_pages
    })
  },
  // watch:{
  //   $route (to, from){
  //     this.fetchData().then(data =>{
  //       this.data = data
  //       this.grouped_pages = data.grouped_pages
  //     })
  //   }
  // },
  methods:{
    fetchData(){
       var id = this.$route.meta.id
       return axios.get('/api/v2/pages/'+id).then(response => {
        //  console.log(JSON.stringify(response))
         return response.data
       })
    },
  }
}
</script>

<style scoped>
.custom-grid {
  /* grid-template-columns: 2fr; */
  grid-template-columns: minmax(min-content, 1000px);

  grid-template-areas:
    "content"
    "footer";
}

.streamfield{
  max-width: 700px;
}

.box {
  background: ghostwhite;
  margin: 4em;
  z-index: 1000;
}
</style>
